import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=7b833f8b&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b833f8b')) {
      api.createRecord('7b833f8b', component.options)
    } else {
      api.reload('7b833f8b', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=7b833f8b&", function () {
      api.rerender('7b833f8b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zPMHLInGe7QP/JS/comp/costHelpSpa.vue"
export default component.exports